var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('kcb-cert', {
    ref: "kcbCert",
    on: {
      "change": function change(payload) {
        return _vm.redirect(payload);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }